import React from 'react';
import style from './mailToLink.module.scss';
import classNames from 'classnames';

interface MailToProps {
    email: string | undefined | null;
    highlight?: boolean;
    truncate?: boolean;
}

const MailTo: React.SFC<MailToProps> = ({email, highlight, truncate, children}) => {
    if (!email) {
        return null;
    }
    return (
        <a
            href={`mailto:${email}`}
            className={classNames({
                [style.Highlight]: highlight,
                [style.Truncate]: truncate
            })}
        >
            {children
                ? children
                : email
            }
        </a>
    );
};

export { MailTo };
